var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogoMetis = function SvgLogoMetis(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 106.15625,
    y1: 126.984383,
    x2: 106.15625,
    y2: 136.060059,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(76.862746%,81.960785%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 65.84375,
    y1: 126.984383,
    x2: 65.84375,
    y2: 136.060059,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(76.862746%,81.960785%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 55.09375,
    x2: 86,
    y2: 77.9375,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(76.862746%,81.960785%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 14.10938,
    x2: 86,
    y2: 159.457443,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(80.392158%,83.92157%,96.470588%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(32.941177%,47.843137%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 14.10938,
    x2: 86,
    y2: 159.457443,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(80.392158%,83.92157%,96.470588%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(32.941177%,47.843137%,100%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface3093732"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 27.34375 37.5 L 34.375 37.5 L 34.375 39.0625 L 27.34375 39.0625 Z M 27.34375 37.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 15.625 37.5 L 22.65625 37.5 L 22.65625 39.0625 L 15.625 39.0625 Z M 15.625 37.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 25 16.40625 C 23.273438 16.40625 21.875 17.804688 21.875 19.53125 C 21.875 21.257812 23.273438 22.65625 25 22.65625 C 26.726562 22.65625 28.125 21.257812 28.125 19.53125 C 28.125 17.804688 26.726562 16.40625 25 16.40625 Z M 25 16.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 41.042969 27.4375 L 34.375 20.769531 L 34.375 18.75 C 34.375 13.84375 31.15625 4.6875 25 4.6875 C 18.84375 4.6875 15.625 13.84375 15.625 18.75 L 15.625 20.769531 L 8.957031 27.4375 C 8.21875 28.175781 7.8125 29.15625 7.8125 30.203125 L 7.8125 35.15625 C 7.8125 36.449219 8.863281 37.5 10.15625 37.5 L 14.0625 37.5 L 14.0625 38.28125 C 14.0625 39.574219 15.113281 40.625 16.40625 40.625 L 17.1875 40.625 L 17.1875 41.40625 C 17.1875 42.699219 18.238281 43.75 19.53125 43.75 L 22.800781 43.75 C 23.125 44.65625 23.984375 45.3125 25 45.3125 C 26.015625 45.3125 26.875 44.65625 27.199219 43.75 L 30.46875 43.75 C 31.761719 43.75 32.8125 42.699219 32.8125 41.40625 L 32.8125 40.625 L 33.59375 40.625 C 34.886719 40.625 35.9375 39.574219 35.9375 38.28125 L 35.9375 37.5 L 39.84375 37.5 C 41.136719 37.5 42.1875 36.449219 42.1875 35.15625 L 42.1875 30.203125 C 42.1875 29.15625 41.78125 28.175781 41.042969 27.4375 Z M 25 6.25 C 29.847656 6.25 32.8125 14.34375 32.8125 18.75 L 32.8125 32.8125 L 29.6875 32.8125 L 29.6875 34.375 L 32.8125 34.375 L 32.8125 35.9375 L 27.34375 35.9375 L 27.34375 32.03125 C 27.34375 30.738281 26.292969 29.6875 25 29.6875 C 23.707031 29.6875 22.65625 30.738281 22.65625 32.03125 L 22.65625 35.9375 L 17.1875 35.9375 L 17.1875 34.375 L 20.3125 34.375 L 20.3125 32.8125 L 17.1875 32.8125 L 17.1875 18.75 C 17.1875 14.34375 20.152344 6.25 25 6.25 Z M 10.15625 35.9375 C 9.726562 35.9375 9.375 35.585938 9.375 35.15625 L 9.375 30.203125 C 9.375 29.574219 9.621094 28.984375 10.0625 28.542969 L 12.5 26.105469 L 12.5 34.375 L 14.0625 34.375 L 14.0625 24.542969 L 15.625 22.980469 L 15.625 35.9375 Z M 16.40625 39.0625 C 15.976562 39.0625 15.625 38.710938 15.625 38.28125 L 15.625 37.5 L 22.65625 37.5 L 22.65625 39.0625 Z M 18.75 41.40625 L 18.75 40.625 L 22.65625 40.625 L 22.65625 42.1875 L 19.53125 42.1875 C 19.101562 42.1875 18.75 41.835938 18.75 41.40625 Z M 25.78125 42.96875 C 25.78125 43.398438 25.429688 43.75 25 43.75 C 24.570312 43.75 24.21875 43.398438 24.21875 42.96875 L 24.21875 32.03125 C 24.21875 31.601562 24.570312 31.25 25 31.25 C 25.429688 31.25 25.78125 31.601562 25.78125 32.03125 Z M 31.25 41.40625 C 31.25 41.835938 30.898438 42.1875 30.46875 42.1875 L 27.34375 42.1875 L 27.34375 40.625 L 31.25 40.625 Z M 34.375 38.28125 C 34.375 38.710938 34.023438 39.0625 33.59375 39.0625 L 27.34375 39.0625 L 27.34375 37.5 L 34.375 37.5 Z M 40.625 35.15625 C 40.625 35.585938 40.273438 35.9375 39.84375 35.9375 L 34.375 35.9375 L 34.375 22.980469 L 35.9375 24.542969 L 35.9375 34.375 L 37.5 34.375 L 37.5 26.105469 L 39.9375 28.542969 C 40.378906 28.984375 40.625 29.574219 40.625 30.203125 Z M 40.625 35.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 25 23.4375 C 27.152344 23.4375 28.90625 21.683594 28.90625 19.53125 C 28.90625 17.378906 27.152344 15.625 25 15.625 C 22.847656 15.625 21.09375 17.378906 21.09375 19.53125 C 21.09375 21.683594 22.847656 23.4375 25 23.4375 Z M 25 17.1875 C 26.292969 17.1875 27.34375 18.238281 27.34375 19.53125 C 27.34375 20.824219 26.292969 21.875 25 21.875 C 23.707031 21.875 22.65625 20.824219 22.65625 19.53125 C 22.65625 18.238281 23.707031 17.1875 25 17.1875 Z M 25 17.1875 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoMetis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoMetis.dd510fec.svg";
export { ForwardRef as ReactComponent };